import { COMPANY_COLUMN_ID } from './getColumnUtils';

export const isCellNumber = (columnId: string) => {
  return columnId !== COMPANY_COLUMN_ID;
};

export const getCellHighlighted = (columnId: string) => {
  return columnId.toLocaleLowerCase().includes('revenue');
};
